import { define } from "../preactement/define";
import { Hint } from "../../Hint";
import { parseBooleanAttr } from "../wrapperUtils";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const attributes = ['class-name', 'inversed', 'requirement-label', 'root-id'];
const Wrapper = _ref => {
  let {
    inversed,
    rootId,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(Hint, {
    ...otherProps,
    inversed: parseBooleanAttr(inversed),
    id: rootId
  });
};

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */

define('ds-hint', () => Wrapper, {
  attributes,
  shadow: true
});